<template>
    <b-container fluid>
        <h2 class="text-center">{{ msg }}</h2>

        <b-row>
          <b-col cols="3">
            <input class="w-100" v-model="dt">
          </b-col>
          <b-col cols="3">{{ rawDate(dt) }}</b-col>
          <b-col cols="4">{{dt | prettyDateTime}}</b-col>
        </b-row>

    </b-container>
</template>

<script>
/* eslint-disable */
'use strict'
import service from "@/service/service"
import utils from "@/utils/utils"

let data = {
    dt: '2020-04-23T01:51:51.617Z',
    msg: 'Test Page',
    debug: false,
    loading: true,
    error: false,
    studentHash: "",
    blurb: "Upcoming: 0",
    classes: []
}

export default {
  name: 'Test',
  data () {
    return data
  },
  methods: {
      rawDate(dateStr) {
          let aout
          // console.log(`parsed: ${Date.parse(dateStr)}`)
          if (!isNaN(Date.parse(dateStr))) {
              aout = (new Date(dateStr)).toString()
          }
          else {
              aout = 'Not a date!'
          }
          return aout
      }
  },
  created() {
    this.studentHash = this.$root.getToken()
    service
      .getUpcoming(this.studentHash)
      .then(res => {
        if (this.debug) console.log(res)
        if (res.status && res.rowCount !== 0) {
          this.blurb = `Upcoming Classes: ${res.rowCount}`
          this.classes = res.data
        } else {
          this.blurb = "No upcoming classes."
        }
      })
      .finally(() => this.loading = false)
      .catch(e => console.log(e))
  },
  mounted() { console.log(`mounted`) }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Test.vue